import { Text } from "@chakra-ui/react";
import { Circle } from "rc-progress";
import "./subscriptionsProgress.css";

export const ProfileSubscriptionsProgress = ({ value }) => {
  return (
    <div>
      <div className="subscriptions-progress-container">
        <div className="subscriptions-progress-percentage">
          <span>{value}</span>%
        </div>
        <Circle
          percent={value}
          strokeWidth={7}
          trailWidth={7}
          strokeColor="var(--ips-primary)"
          trailColor="var(--ips-border)"
          className="subscriptions-progress-circle"
          strokeLinecap="butt"
        />
      </div>
      <Text textAlign="center">Lookups used</Text>
    </div>
  );
};
